<template>
  <main class="app-content">
    <div class="app-title">
      <div>
        <h1>
          <font-awesome-icon icon="history"/>
          {{ $t('snaHistory') }}
        </h1>
      </div>
    </div>
    <b-tabs>
      <b-tab :title="$t('facebookHistory')">
        <facebook-history></facebook-history>
      </b-tab>
      <b-tab :title="$t('zaloOAHistory')">
        <zalo-o-a-history></zalo-o-a-history>
      </b-tab>
      <b-tab :title="$t('chatBotHistory')">
        <chat-bot-history></chat-bot-history>
      </b-tab>
      <b-tab :title="$t('chatSessionHistory')">
        <chat-session-history></chat-session-history>
      </b-tab>
      <b-tab :title="$t('whatsappHistory')">
        <whatsapp-history></whatsapp-history>
      </b-tab>
    </b-tabs>
  </main>
</template>

<script>
import FacebookHistory from "@/views/facebook/History.vue";
import ZaloOAHistory from "@/views/zalo-oa/History.vue";
import ChatBotHistory from "@/views/chatbot/History.vue";
import ChatSessionHistory from "@/views/chat-session/History.vue";
import WhatsappHistory from "@/views/message/WhatsappHistory.vue";

export default {
  components: {FacebookHistory, ZaloOAHistory, ChatBotHistory, ChatSessionHistory, WhatsappHistory},
  i18n: {
    messages: {
      en: {
        snaHistory: "Social network accounts history",
        facebookHistory: "Facebook history",
        zaloOAHistory: "Zalo OA history",
        chatBotHistory: "Chat bot history",
        chatSessionHistory: "Chat session history",
        whatsappHistory: "Whatsapp history",
      },
      vi: {
        snaHistory: "Lịch sử tài khoản mạng xã hội",
        facebookHistory: "Lịch sử Facebook",
        zaloOAHistory: "Lịch sử Zalo OA",
        chatBotHistory: "Lịch sử Chat bot",
        chatSessionHistory: "Lịch sử phiên chat",
        whatsappHistory: "Lịch sử Whatsapp",
      }
    }
  }
}
</script>